export function Footer() {
  return (
    <footer className={'p-2'}>
      <p>&copy; 2025 Jan Kos</p>
    </footer>
  )
}
